
import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, StepperComponent, SelectizeComponent } from '../../blocks';
import { Location } from '@angular/common';
import { GroupAppCodePermission, UserAppCodePermission, UserService } from '../userData/user.service';
import { UserSessionService, ControlsParams, AppCodeGroup } from '../../shared';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { ModalService } from '../../blocks';
import { AppCode } from '../../hospitalSetup/app-code/appcode';

@Component({
    selector: 'sanabel-usersAppCodePrivilege',
    templateUrl: './appcode.component.html',
})


export class AppCodeComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++// 
    UserAppCodePermission: UserAppCodePermission = <UserAppCodePermission>{};
    GroupAppCodePermission: GroupAppCodePermission = <GroupAppCodePermission>{};
    permission = 1;
    appCode: number;
    GroupID: number;
    childLinks: any[];
    @Input() myStepNumber: number;
    @Input() stepperComponent: StepperComponent;
    appCodesByLinks: any[];
    appCodeArr: any[];
    SecLoginsID: number;
    controlsParams: ControlsParams;
    userAppCodePermission: UserAppCodePermission[] = [];
    groupAppCodePermission: GroupAppCodePermission[] = [];
    allData: any;
    allDataAsGroup: any;
    linkCODE: number;
    // stepper
    @Input() appCodeType: number;

    @ViewChild('secLoginSeclectize') secLoginSeclectize: SelectizeComponent;
    groupCode: any;
    userId: number;
    activeTabSerial: number = 6584
    defaultTab: number = 6584;
    showAppCodesStpSelectize: boolean
    userAppCodes: any[]
    userAppCodesFilter: any[]
    constructor(
        private _userSessionService: UserSessionService,
        private _userService: UserService,
        public translate: TranslateService,
        private _modalService: ModalService,
        private _location: Location,
        private _toastService: ToastService) {
        this.controlsParams = new ControlsParams(555, AppCodeGroup.Buttons, true);
    }

    activateTab(e: AppCode) {
        //6584 =>All User Links
        //6585 =>All User AppCodes
        this.activeTabSerial = e.serial;
        this.selectedAppCodes = []
        this.unselectedAppCodes = []
        if (e.serial == 6585) {
            this.showAppCodesStpSelectize = true
            this.getUserAppCodes()
        }
        else {
            this.showAppCodesStpSelectize = false
        }
    }

    onClicked(e: number): void {
        switch (e) {
            case 1: // save code
                this.save();
                break;

            default:
                this.cancel();

        }
    }
    cancel(showToast = true) {

        this._goBack();
    }
    //  ++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++
    _goBack(): void {
        this._location.back();
    }

    // // // // // //////////////////////////////////////////////#Gouhar///////////////////////////////////////////
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();

    }
    ngOnInit() {
        this._userSessionService.subscribeToKey$('userParms').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    let user = keys.value;
                    this.userId = +user.userID;
                    console.log(this.userId);

                }
            });

    }


    // links by secLogins
    getlinks(groupCode: any) {
        this.childLinks = [];
        this.appCodesByLinks = [];
        this._userService.getLinksBySecLoginss(this.SecLoginsID, 2).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(
                links => {
                    if (links.data.length > 0) {
                        this.childLinks = links.data;
                    }
                    this.childLinks = this.childLinks.filter(data => data.groupID == groupCode);
                    console.table(this.childLinks);
                }),
            error => console.log(error),
            () => {
                null
            };
    }

    getUserAppCodes() {
        this.userAppCodes = []
        this.userAppCodesFilter = []
        this._userService.getUserAppCodePer(this.SecLoginsID).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(
                appCodes => {
                    if (appCodes.data.length > 0) {
                        this.userAppCodes = appCodes.data;
                        this.userAppCodesFilter = appCodes.data;
                    }
                }),
            error => console.log(error),
            () => {
                null
            };


    }
    onRowIconClick(actionCode: number, link: any) {
        if (actionCode == 404) {
            this.getAppCodesByLinkIds(link['code']);
        }
        if (actionCode == 403) {
            this.delete(link)
        }
        if (actionCode == 402) {
            this.update(link)
        }
    }
    //update include or exclude
    update(row: any) {
        row.dataStatus = 2;
    }
    searchinAppCodes(val: any) {
        this.userAppCodesFilter = [];
        if (val) {
            this.userAppCodesFilter = this.userAppCodes.filter(x =>
                x.appCodeNameAr.toLowerCase().include(val.toLowerCase()) ||
                x.appCodeNameEn.toLowerCase().include(val.toLowerCase()) ||
                x.appCode.toString().include(val)
            )
        } else {
            this.userAppCodesFilter = this.userAppCodes
        }
    }

    //_____________Asmaa________
    admAppCodesStpClicked(codeItem) {
        this.selectedAppCodes = []
        this.unselectedAppCodes = []
        if (codeItem) {
            codeItem.forEach(ele => {
                ele.dataStatus = 1;
                ele.selected = true;
                ele.appCodeNameAr = ele.nameAr;
                ele.appCodeNameEn = ele.nameEn;
                ele.appCode = ele.code
                if (!this.userAppCodesFilter.find(x => x.appCode == ele.appCode)) {
                    this.userAppCodesFilter.push(ele);
                } else {
                    this._toastService.toastMsg(ele.nameAr + "  is already exsist", "Warning", "Warn");
                }
                // this.checkIncludeOrExclude(ele); 
            });
        }
    }
    checkIncludeOrExclude(ele: any) {
        if (ele.inOutFlag == 1) {
            this.selectedAppCodes.push(ele)
        }
        else if (ele.inOutFlag == 0) {
            this.unselectedAppCodes.push(ele)
        }
    }
    //__________________________

    selectedAppCodes: any[] = [];
    unselectedAppCodes: any[] = [];
    getAppCodesByLinkIds(link: any) {
        if (link) {
            this.linkCODE = link;
        }
        this.appCodesByLinks = [];
        this._userService.SecLoadLinksAppCodes(link, this.SecLoginsID).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(
                links => {
                    if (links.data.length > 0) {
                        // this.appCodeArr = links.data1;
                        this.appCodesByLinks = links.data;
                    }
                },
                err => console.log(err),
                () => {
                    this.selectedAppCodes = this.appCodesByLinks.filter(el => el.selected == 1);
                    this.unselectedAppCodes = this.appCodesByLinks.filter(el => el.selected == 0);
                    //////////////////////////////////////////
                    console.log(this.selectedAppCodes);
                    console.log(this.unselectedAppCodes);
                });

    }

    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//

    onPermissionModeChange(mode: number) {
        this.permission = mode;
    }


    GroupClicked(item: any) {
        this.GroupID = item.code;
        this.appCodesByLinks = [];
        this.AppCodeGrouprPermission(this.GroupID);
    }
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//

    SecLoginsClicked(item: any) {
        if (item && item.active == 0 && item.active != null) {
            this._toastService.activateMsg('UI48');
            this.resetForm();
            return false;
        }
        if (item) {
            this.SecLoginsID = item.code;
            this.groupCode = item.groupId;
            this.AppCodeUserPermission(this.SecLoginsID);
            this.getlinks(this.groupCode);
            this.getUserAppCodes()
        }

    }
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++// 

    // #ibrahim save app code permission

    save() {
        this.userAppCodePermission = [];
        this.appCodesByLinks = [];
        let newArr;
        if (this.activeTabSerial == 6585) {
            newArr = this.userAppCodesFilter.filter(x => x.dataStatus == 1 || x.dataStatus == 2 || x.selected)
        } else {
            newArr = this.selectedAppCodes.concat(this.unselectedAppCodes);
        }
        this.appCodesByLinks = newArr;
        if (this.appCodesByLinks.length > 0) {
            for (let i = 0; i < this.appCodesByLinks.length; i++) {
                if ((this.appCodesByLinks[i].serial > 0 && !this.appCodesByLinks[i].selected)
                    || (this.appCodesByLinks[i].selected && this.appCodesByLinks[i].serial == null || undefined)
                    || (this.appCodesByLinks[i].selected && this.appCodesByLinks[i].serial > 0)
                ) {
                    let prem: UserAppCodePermission = {
                        serial: (this.appCodesByLinks[i].serial ? this.appCodesByLinks[i].serial : (i + 1) * -1),
                        appCode: this.appCodesByLinks[i].appCodeSerial ? this.appCodesByLinks[i].appCodeSerial : this.appCodesByLinks[i].appCode,
                        secLoginId: this.SecLoginsID,
                        selected: this.appCodesByLinks[i].selected,
                        inOutFlag: this.appCodesByLinks[i].inOutFlag
                    }
                    this.userAppCodePermission.push(prem);
                }

            }
        }
        if (this.userAppCodePermission.length > 0) {
            this._userService.addUserAppCodePermission(this.userAppCodePermission).pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe(c => {
                    if (this.linkCODE == (undefined || null)) {
                        this.appCodesByLinks = [];
                    } else {
                        this.getAppCodesByLinkIds(this.linkCODE);
                    }
                },
                    error => console.log(error),
                    () => {
                        if (this.activeTabSerial = 6585) { this.getUserAppCodes() }
                    });
        }
    }





    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++// 

    // /fubction to get AppCodeUserPermission history of data by ecLogins Id
    AppCodeUserPermission(SecLoginsID: number) {

        this.userAppCodePermission = [];
        this._userService.getUserAppCodePer(SecLoginsID).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(
                res => {

                    if (res.data.length > 0) {

                        this.userAppCodePermission = res.data;

                    }
                },
                error => console.log(error),
                () => {
                    null
                });
    }
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++// 
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++// 
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++// 


    // /fubction to get AppCodeGroupPermission history of data by ecLogins Id
    AppCodeGrouprPermission(GroupID: number) {

        this.groupAppCodePermission = [];
        this._userService.getGroupAppCodePer(GroupID).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(
                appCodeGroupPermission => { this.allDataAsGroup = appCodeGroupPermission; },
                error => console.log('unable to load appCodeGroupPermission'),
                () => {
                    if (this.allDataAsGroup.data.length > 0) {
                        this.groupAppCodePermission = this.allDataAsGroup;
                    }
                    console.log(this.allDataAsGroup);
                });
    }
    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++// 


    delete(appCode: any) {

        this._modalService.activeDelMes(appCode.appCodeNameAr, appCode.appCodeNameAr).then(responseOK => {
            if (responseOK) {
                this._userService.deleteAppCode(appCode)
                    .subscribe(c => {
                    }, error => console.log(error),
                        () => this.getUserAppCodes());
            }
        });
    }



    // ++++++++++++++++++++++++++++++++++++++gouhar++++++++++++++++++++++++++++++++++++++//

    resetForm() {
        this.secLoginSeclectize.clear();
        this.secLoginSeclectize.clearItems();
        this.groupAppCodePermission = [];
        this.userAppCodePermission = [];
        this.childLinks = [];
        this.appCodesByLinks = [];

    }
    //crad operation
    saveAppCode() {

    }
    updateAppCode() {

    }
    deleteAppCode() {

    }
}

